import { Component } from '@angular/core';

@Component({
	selector: 'q4sg-root',
	template: '<router-outlet></router-outlet>'
})
export class AppComponent { }
